import { render, staticRenderFns } from "./IosPwaBanner.vue?vue&type=template&id=a63a3c28&scoped=true&"
import script from "./IosPwaBanner.vue?vue&type=script&lang=js&"
export * from "./IosPwaBanner.vue?vue&type=script&lang=js&"
import style0 from "./IosPwaBanner.vue?vue&type=style&index=0&id=a63a3c28&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a63a3c28",
  null
  
)

export default component.exports